<div class="di-bandeau-facturation-degradee">
	<lua-papier shadowVariant="strong">
		<div class="container">
			<div class="label">
				<strong>{{invoicesChecked.length === 0 ? "Aucune" : invoicesChecked.length}} {{invoicesChecked.length>1 ? "factures sélectionnées" : "facture sélectionnée"}}</strong>
			</div>
			<div class="bouton-facturation">
				<lua-action-principale libelle="Facturation dégradée" (click)="handleFacturer()"></lua-action-principale>
			</div>
			<div class="bouton-selection">
				<lua-bouton-texte [libelle]="toutSelectionner ? 'Tout sélectionner' : 'Tout déselectionner'" (click)="handleSelectionner()"></lua-bouton-texte>
			</div>
		</div>
	</lua-papier>
</div>
